import {type CreatePaymentMethodBancontactData} from '@stripe/stripe-js';
import {type StripeGateway, type IStripeContext} from '../../../models/stripe';
import {PeachPayCustomer} from '../../../reducers/peachPayCustomerReducer';
import {getLocaleText} from '../../../util/translation';
import bancontactBadgeURL from '../../../../img/badge/bancontact.svg';
import bancontactImageURL from '../../../../img/marks/bancontact.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';

function initStripeBancontactMethod(): StripeGateway {
	return {
		config: {
			name: Feature.metadata<string>(FeatureFlag.STRIPE_BANCONTACT_GATEWAY, 'title') ?? 'Bancontact',
			gatewayId: 'peachpay_stripe_bancontact',
			description: getLocaleText('After selecting <b>Pay</b> you will be redirected to complete your payment.'),
			assets: {
				title: {src: bancontactImageURL},
				badge: {src: bancontactBadgeURL},
			},
		},
		async tokenize(context) {
			const {stripe} = context;

			const {paymentMethod, error} = await stripe.createPaymentMethod({
				type: 'bancontact',
				billing_details: PeachPayCustomer.stripeBillingDetails(),
			} as CreatePaymentMethodBancontactData);

			if (error) {
				const message = error.message ?? 'Failed to tokenize payment method.';

				return [null, {
					paymentStatus: 'creationfailed',
					note: message,
				}];
			}

			if (!paymentMethod?.id) {
				return [null, {
					paymentStatus: 'creationfailed',
					note: 'Failed to tokenize payment method.',
				}];
			}

			return [paymentMethod.id, {}];
		},
		async confirm(context: IStripeContext, clientSecret: string, intermediateURL: string) {
			const {stripe} = context;

			const {paymentIntent, error} = await stripe.confirmBancontactPayment(clientSecret, {return_url: intermediateURL});

			if (error) {
				const message = error.message ?? 'Failed to confirm payment.';
				return [null, {
					note: message,
				}];
			}

			if (paymentIntent) {
				return ['success', {}];
			}

			return [null, {}];
		},
	};
}

export {initStripeBancontactMethod};
